export const SET_SHIPPINGS = "SHIPPING/SET_SHIPPINGS"
export const SET_SHIPPING_METHOD = "SHIPPING/SET_SHIPPING_METHOD"
export const SET_LOADING_CALCULATE = "SHIPPING/SET_LOADING_CALCULATE"
export const SET_CEP_DESTIONATION = "SHIPPING/SET_CEP_DESTIONATION"
export const START_REQUEST = "SHIPPING/START_REQUEST"
export const FINISH_REQUEST = "SHIPPING/FINISH_REQUEST"